import { BookingInTicketingReportModule } from "app_sasha/pages/booking-in-ticketing-report/booking-in-ticketing-report.module";

export enum SashaEntryPoints {
    home = 'home',
    booking = 'booking',
    treatment = 'treatment',
    processing = 'processing',
    processingQualityCheck = 'processing-qualityCheck',
    processingIssuing = 'processing-issuing',
    processingCancel = 'processing-cancellation',
    processingVoiding = 'processing-voiding',
    processingEmail = 'processing-email',
    processingSms = 'processing-sms',
    ticketingReport = 'ticketing-report',
    processReport = 'process-report',
    bookingInTicketingReport = 'booking-in-ticketing-report',
    importBooking = 'import-booking',
    dashboard = 'dashboard',
}
